import {
  Autocomplete,
  Button,
  Container,
  FormControl,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { GangResponseDto } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { SelectedEquipmentHelmet } from '../components/SelectEquipment/SelectedEquipmentHelmet'
import { EquipmentOperatorWorkInstructionFormData } from '../stores/equipment-operator-work-instructions.ui-store'

export const GeneralCargoOperatorLandingContainer = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const { gangStore, equipmentOperatorWorkInstructionsUIStore } = useOperationsStore()

  useEffect(() => {
    const loadPageData = async () => {
      gangStore.fetchData()
    }

    loadPageData()
  }, [gangStore.items])

  const onSubmit = async (data: EquipmentOperatorWorkInstructionFormData) => {
    equipmentOperatorWorkInstructionsUIStore.selectGang(data.gang)
  }

  const form = useForm<EquipmentOperatorWorkInstructionFormData>()

  return (
    <>
      <SelectedEquipmentHelmet />

      <Container sx={{ backgroundColor: theme.palette.grey[200], height: '100vh' }}>
        <Stack justifyContent='center' alignItems='center' height={'70vh'} width={'100%'}>
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} noValidate>
              <Stack gap={theme => theme.customSpacing.l} width={'270px'} alignItems='center'>
                <Typography variant='h1'>{t('selectGang', 'Select gang')}</Typography>

                <Controller
                  control={form.control}
                  name={'gang'}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <FormControl fullWidth>
                      <Autocomplete
                        options={equipmentOperatorWorkInstructionsUIStore.gangOptions}
                        onChange={(_: any, newValue: GangResponseDto | null) => {
                          onChange(newValue)
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        getOptionLabel={option => option.name ?? ''}
                        fullWidth
                        data-cy='operator-select-gang-field'
                        renderInput={params => (
                          <TextField {...params} label={t('gang', 'Gang')} required />
                        )}
                      />
                    </FormControl>
                  )}
                />

                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  fullWidth
                  disabled={!form.formState.isValid}
                  data-cy='operator-landing-continue-btn'
                >
                  {t('continue', 'Continue')}
                </Button>
              </Stack>
            </form>
          </FormProvider>
        </Stack>
      </Container>
    </>
  )
})
